import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import moment from 'moment'
import { images } from '../../assets'
import style from './prescription.module.css'
import css from '../consultation/consultation.module.css'
import { database } from '../../utils/firebase'
import { path } from '../../utils/const'
import BackComponent from '../../components/BackComponent/BackComponent'

const ViewPerscription = () => {
  const [age, setAge] = useState(0)
  const [patient, setPatient] = useState({})
  const [name, setName] = useState('')
  const [gender, setGender] = useState('')
  const [healthCardNumber, setHealthCardNumber] = useState('')
  const [archiveData, setArchiveData] = useState([])
  const [medications, setMedications] = useState([])
  const [delegateConvoData, setDelegateConvoData] = useState({})
  const [pharmacyData, setPharmacyData] = useState([])
  const navigate = useNavigate()
  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const patientId = query.get('Id')
  const past = query.get('Past')
  const archiveId = query.get('archiveId')

  useEffect(async () => {
    try {
      const patientSnapshot = await database
        .ref(`/users/${patientId}`)
        .once('value')
      const patientData = patientSnapshot.toJSON() || {}
      setPatient(patientData)
      let date = moment(patientData.DOB, 'MMMM DD YYYY')
      let years = moment().diff(date, 'years')
      setAge(years)
      setName(patientData.name || patientData.userName || '')
      setGender(patientData.gender || '')
      setHealthCardNumber(patientData.healthInsuranceCardNumber || '')

      // eslint-disable-next-line no-shadow
      const pharmacyData = patientSnapshot.pharmacy || {}
      setPharmacyData(pharmacyData)

      let archiveSnapshot = await database
        .ref(`/archiveConversations/${archiveId}`)
        .once('value')
      if (!archiveSnapshot.exists()) {
        archiveSnapshot = await database
          .ref(`/openconversations/${archiveId}`)
          .once('value')
      }
      const archiveConversationsData = archiveSnapshot.toJSON() || {}
      setArchiveData(archiveConversationsData)
      if (
        archiveConversationsData.owner &&
        patientData.profiles &&
        patientData.profiles[archiveConversationsData.owner]
      ) {
        date = moment(
          patientData.profiles[archiveConversationsData.owner].DOB,
          'MMMM DD YYYY',
        )
        years = moment().diff(date, 'years')
        setAge(years)
        setName(
          patientData.profiles[archiveConversationsData.owner].name ||
          patientData.profiles[archiveConversationsData.owner].userName ||
          '',
        )
        setGender(
          patientData.profiles[archiveConversationsData.owner].gender || '',
        )
        setHealthCardNumber(
          patientData.profiles[archiveConversationsData.owner]
            .healthInsuranceCardNumber || '',
        )
      }
      if (archiveConversationsData.prescriptionData) {
        setMedications(
          Object.values(
            archiveConversationsData.prescriptionData?.medications || {},
          ),
        )
      } else {
        setMedications([])
      }
      const delegateSnapshot = await database
        .ref(`/delegateChats/${archiveId}`)
        .once('value')
      const delegateConversationsData = delegateSnapshot.toJSON() || {}
      setDelegateConvoData(delegateConversationsData)
    }
    catch (e) {
      console.log(e)
    }
  }, [])

  const navigateToChat = (id) => {
    query.set('Id', id)
    query.set('delegateConversationID', delegateConvoData.conversationID)
    const chatPath = path.ChatModule
    const paramsString = query.toString()
    const url = new URL(window.location.href)
    url.search = paramsString
    navigate(chatPath + url.search)
    // navigate("ChatModule")
  }

  return (
    <div>
      <BackComponent title={'Back'} />

      <div className={css.iconAlign}>
        {delegateConvoData.conversationID ? (
          <button
            className={css.backgroundCall}
            onClick={(event) =>
              navigateToChat(patientId, delegateConvoData.conversationID)
            }
          >
            <img src={images.chatIcon} className={css.chatIcon} alt="logo" />
          </button>
        ) : (
          <button className={css.backgroundCall}>
            <img
              src={images.chatInactiveIcon}
              className={css.chatIcon}
              alt="logo"
            />
          </button>
        )}
        <button className={css.backgroundCall}>
          <img src={images.phoneIcon} className={css.chatIcon} alt="logo" />
        </button>
        <button className={css.backgroundCall}>
          <img src={images.videoIcon} className={css.chatIcon} alt="logo" />
        </button>
      </div>

      <div className={style.patientInformationRoot}>
        <div className={css.patientInformation}>
          <span className={css.bold}>Patient</span>
          <span>{name}</span>

          <span className={css.bold}>Issue</span>
          <span>
            {archiveData?.assessment || delegateConvoData.assessment || '-'}
          </span>

          <span className={css.bold}>Gender</span>
          <span>{gender}</span>

          <span className={css.bold}>Age</span>
          <span>{age} years old</span>

          <span className={css.bold}>Encounter Date</span>
          <span>
            {moment(new Date(archiveData?.timestamp)).format(
              'MM/DD/YY (HH:mm)',
            )}
          </span>

          <span className={css.bold}>Phone number</span>
          <span>{patient.phone_number}</span>

          <span className={css.bold}>State</span>
          <span>{patient.state}</span>

          <span className={css.bold}>Health card #</span>
          <span>{healthCardNumber}</span>
        </div>
        <hr className={css.hr}></hr>

        <div className={css.subjective}>
          <span className={css.bold}>Assessment</span>
          <p className={css.paragraph}>
            {archiveData?.assessment || delegateConvoData.assessment || ''}
          </p>

          <span className={css.bold}>Plan</span>
          <p className={css.paragraph}>
            {archiveData?.plan || delegateConvoData.plan || ''}
          </p>

          <span className={css.bold}>Allergies</span>
          <p className={css.paragraph}>
            {archiveData?.prescriptionData?.allergies ||
              delegateConvoData?.prescriptionData?.allergies ||
              ''}
          </p>

          <span className={css.bold}>Known medical condition</span>
          <p className={css.paragraph}>
            {archiveData?.prescriptionData?.medicalCondition ||
              delegateConvoData?.prescriptionData?.medicalCondition ||
              ''}
          </p>

          <span className={css.bold}>Current medications</span>
          <p className={css.paragraph}>
            {archiveData?.prescriptionData?.previousMedications ||
              delegateConvoData?.prescriptionData?.previousMedications ||
              ''}
          </p>

          <span className={css.bold}>Prescription</span>
          <p className={css.paragraph}>
            {archiveData?.prescriptionData?.medicationNames ||
              delegateConvoData?.prescriptionData?.medicationNames ||
              ''}
          </p>

          <span className={css.bold}>Pharmacy details</span>
          <div className={style.pharmacyDetail}>
            <div className={style.row}>
              <span className={css.bold}>Address:</span>
              <span className={style.fontsize}>
                {pharmacyData?.address ||
                  delegateConvoData?.pharmacy?.address ||
                  ''}
              </span>
            </div>
            <div className={style.row}>
              <span className={css.bold}>Fax number:</span>
              <span className={style.fontsize}>
                {pharmacyData?.fax_number ||
                  delegateConvoData?.pharmacy?.address ||
                  ''}
              </span>
            </div>

            <div className={style.row}>
              <span className={css.bold}>Name:</span>
              <span className={style.fontsize}>
                {pharmacyData?.name ||
                  delegateConvoData?.pharmacy?.address ||
                  ''}
              </span>
            </div>

            <div className={style.row}>
              <span className={css.bold}>Phone number:</span>
              <span className={style.fontsize}>
                {pharmacyData?.phone_number ||
                  delegateConvoData?.pharmacy?.address ||
                  ''}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className={css.buttonDiv}>
        <button className={css.endButton}>View PDF</button>
        <button className={style.disableButton}>Approve</button>
        <button className={style.disableButton}>Decline</button>
        <button className={style.disableButton}>Suggest Edits</button>
      </div>
    </div>
  )
}
export default ViewPerscription
